import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

import WebMobileServices from "../about/WebMobileServices";
import TimelineSection from "../about/TimelineSection";


// About Us Page component that bundles its sections
function AboutUsPage() {
  return (
    <>
      <WebMobileServices />
      <TimelineSection />
    </>
  );

}

export default AboutUsPage;